// extracted by mini-css-extract-plugin
module.exports = {"main-layout-mobile":"MainLayoutMobile_main-layout-mobile__2PsdS","body":"MainLayoutMobile_body__3ocri","body-no-tabbar":"MainLayoutMobile_body-no-tabbar__aNlAL"};